import "../layouts/default";

if ($('.js-form-account-claim')) {
    import("../pages/account/account-claims");
}

$(function() {
	$('.js-form-lost-password').validate({
        submitHandler: function(form) {
            window.assignRecaptchaResponseToForm(form).then(() => {
                form.submit();
            });
        }
	});
});